import React, { useRef, useEffect } from "react";
import "../assets/css/landing.css";
import LandingHeroSection from "../components/LandingPage/landingHeroSection";
import LandingHeader from "../components/LandingPage/landingHeader";
import LandingFooter from "../components/LandingPage/landingFooter";
import LandingAbout from "../components/LandingPage/landingAbout";
import LandingWhoCan from "../components/LandingPage/landingWhoCan";
import LandingVision from "../components/LandingPage/landingVision";
import LandingOthers from "../components/LandingPage/landingOthers";
import LandingFAQs from "../components/LandingPage/landingFAQs";

import AOS from 'aos';
import 'aos/dist/aos.css';

export const Landingpage: React.FC = () => {
  const aboutRef = useRef<HTMLDivElement>(null);
  const newsletterRef = useRef<HTMLDivElement>(null);
  const faqsRef = useRef<HTMLDivElement>(null);

  const scrollTo = (id: string) => {
    let element: HTMLElement | null = null;
    switch (id) {
      case "about":
        element = document.getElementById("about") || aboutRef.current;
        break;
      case "how-it-works":
        element = document.getElementById("how-it-works");
        break;
      case "newsletter":
        element = document.getElementById("newsletter") || newsletterRef.current;
        break;
      case "FAQs":
        element = document.getElementById("FAQs") || faqsRef.current;
        break;
      default:
        element = null;
    }
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div className="landing relative bg-slate-50 min-h-screen selection:bg-blue-500 selection:text-white">
      <LandingHeader scrollTo={scrollTo} />
      <main>
        <LandingHeroSection />
        <div ref={aboutRef}>
          <LandingAbout />
        </div>
        <LandingWhoCan />
        <LandingVision />
        <div ref={newsletterRef}>
          <LandingOthers />
        </div>
        <div ref={faqsRef}>
          <LandingFAQs />
        </div>
      </main>
      <LandingFooter />
    </div>
  );
};

export default Landingpage;
